var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDineIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "table-restaurant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.31715 7.28995H16.6654L15.945 4.85656H4.05976L3.31715 7.28995ZM14.184 8.75825H5.78146L5.55721 10.6099H14.4425L14.184 8.75825ZM3.38389 15.7919L4.33028 8.75825H2.56409C2.28125 8.75825 2.04684 8.63879 1.86086 8.39985C1.67487 8.16077 1.62237 7.90152 1.70335 7.6221L2.74896 4.01117C2.80028 3.81599 2.90699 3.66056 3.0691 3.54487C3.23106 3.42904 3.41126 3.37684 3.6097 3.38826H16.39C16.5884 3.38826 16.7686 3.44617 16.9306 3.56201C17.0927 3.67769 17.1994 3.83312 17.2507 4.0283L18.2963 7.6221C18.3773 7.90152 18.3248 8.16077 18.1388 8.39985C17.9528 8.63879 17.7184 8.75825 17.4356 8.75825H15.6351L16.5987 15.8141C16.6317 16.0184 16.5761 16.2026 16.4318 16.3667C16.2875 16.5311 16.1058 16.6132 15.8867 16.6132C15.7042 16.6132 15.5481 16.5547 15.4187 16.4377C15.2892 16.3208 15.2079 16.1711 15.1748 15.9885L14.6391 12.0782H5.34341L4.80771 16.0057C4.77463 16.1883 4.69336 16.3352 4.56388 16.4464C4.4344 16.5576 4.27837 16.6132 4.0958 16.6132C3.87674 16.6132 3.69506 16.5311 3.55075 16.3667C3.40644 16.2026 3.35082 16.0109 3.38389 15.7919Z",
    fill: "#334155"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineIn);
export default __webpack_public_path__ + "static/media/dine-in.8d2cec9e577446efa478d813354354dc.svg";
export { ForwardRef as ReactComponent };